import { useActionsSettings } from '@/domain/state'
import { useActionsSharedState } from '@/domain/state/actions-shared-state'
import { SettingsDialog } from '@/features/actions/settings-dialog/components/SettingsDialog'
import { useSettingsDialog } from '@/features/actions/settings-dialog/logic/useSettingsDialog'
import { Info } from '@/ui/molecules/info/Info'
import { cn } from '@/ui/utils/style'

export interface TransactionOverviewSlippageProps {
  allowChangeWhenActionsInProgress?: boolean
  infoText?: string
  dataTestId?: string
}

export function TransactionOverviewSlippage({
  allowChangeWhenActionsInProgress,
  infoText,
  dataTestId,
}: TransactionOverviewSlippageProps) {
  const actionSettings = useActionsSettings()
  const settingsDialogProps = useSettingsDialog()
  const { actionsSettingsEnabled: _actionsSettingsEnabled } = useActionsSharedState()
  const actionsSettingsEnabled = allowChangeWhenActionsInProgress ? true : _actionsSettingsEnabled

  const trigger = (
    <span
      className={cn('underline', actionsSettingsEnabled ? 'cursor-pointer' : 'cursor-not-allowed')}
      data-testid={dataTestId}
    >
      {percentageFormatter.format(actionSettings.exchangeMaxSlippage.times(100).toNumber())}%
    </span>
  )

  return (
    <div className="typography-label-2 flex items-center gap-2 text-primary">
      <SettingsDialog
        {...settingsDialogProps}
        disabled={!actionsSettingsEnabled}
        actionsGridLayout="compact"
        trigger={trigger}
      />
      {infoText && <Info>{infoText}</Info>}
    </div>
  )
}

const percentageFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 5,
})
